export default "__VITE_ASSET__7e86c815__"